import { ClientType } from '../apollo'
import { types } from '../types'
import gql from 'graphql-tag'

import { findUniqueAccountInfo } from '@dinosband/bv-main-schema/dist/client-gql'

export async function readAccountInfo (client: ClientType, where?: types.AccountInfoWhereUniqueInput): Promise<types.AccountInfo | undefined> {
  try {
    const result = await client.query({
      query: findUniqueAccountInfo,
      variables: {
        where,
      } as types.QueryFindUniqueAccountInfoArgs,
    })
    return result.data.findUniqueAccountInfo
  } catch (e) {
  }
}

const _findFirstAccountInfo = gql`
  query _findFirstAccountInfo($where: AccountInfoWhereInput!, $take: Int, $orderBy: [AccountInfoOrderByWithRelationInput!]) {
    findFirstAccountInfo(where: $where, take: $take, orderBy: $orderBy) {
      id
      bankCode
      bankName
      bankAccountNo
      bankAccountHolder
    }
  }
`

export async function readAccountInfoEx (client: ClientType, where?: types.AccountInfoWhereInput): Promise<types.AccountInfo | undefined> {
  try {
    const result = await client.query({
      query: _findFirstAccountInfo,
      variables: {
        where,
      } as types.QueryFindFirstAccountInfoArgs,
    })
    return result.data.findFirstAccountInfo
  } catch (e) {
  }
}
